import { z } from 'zod';

import { jobPostLocationTypeSchema, jobPostRegionSchema } from '~/api/jobPosts/schemas';
import { availableActivityIdSchema } from '~/api/user/schemas';
import { routes } from '~/providers/RouterProvider/router.routes';

const SESSION_STORAGE_KEY = 'jobPosts';

const jobPostFiltersSchema = z.object({
  activityIds: z.array(availableActivityIdSchema),
  regions: z.array(jobPostRegionSchema),
  locationType: jobPostLocationTypeSchema.nullable(),
});

type JobPostFilters = z.infer<typeof jobPostFiltersSchema>;

export const persistJobPostFiltersInSession = (filters: JobPostFilters) => {
  if (window.location.pathname !== routes.jobPosts) {
    // HACK: navigating from the job post overview page to any other page triggers the nuqs filters (why?!)
    return;
  }

  const serializedData = JSON.stringify(filters);
  window.sessionStorage.setItem(SESSION_STORAGE_KEY, serializedData);
};

export const retrieveJobPostFiltersFromSession = (): JobPostFilters | null => {
  try {
    if (window.location.pathname !== routes.jobPosts) {
      // HACK: navigating from the job post overview page to any other page triggers the nuqs filters (why?!)
      return null;
    }

    const serializedData = window.sessionStorage.getItem(SESSION_STORAGE_KEY);

    return serializedData !== null ? jobPostFiltersSchema.parse(JSON.parse(serializedData)) : null;
  } catch {
    return null;
  }
};
